import { render, staticRenderFns } from "./ManageClients.vue?vue&type=template&id=ea583c7c&scoped=true&"
import script from "./ManageClients.vue?vue&type=script&lang=js&"
export * from "./ManageClients.vue?vue&type=script&lang=js&"
import style0 from "./ManageClients.vue?vue&type=style&index=0&id=ea583c7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea583c7c",
  null
  
)

export default component.exports